export const getApiBaseUrl = () => {
    if (typeof window !== 'undefined' && window.location) {
        const host = window.location.hostname;
        if (host === 'localhost' || host === '127.0.0.1') {
            return 'http://localhost:8085';
        }
    }
    return '';
};

export const getWebSocketUrl = () => {
    if (typeof window !== 'undefined' && window.location) {
        const host = window.location.hostname;
        if (host === 'localhost' || host === '127.0.0.1') {
            return 'http://localhost:8085/ws';
        }
        const proto = window.location.protocol === 'https:' ? 'https:' : 'http:';
        return proto + '//' + window.location.host + '/ws';
    }
    return '/ws';
};

export const config = {
    features: {
        musicEasterEgg: true, // Easter egg feature toggle
        musicDelay: 10, // Music playback delay in ms
    },
    get api() {
        const baseUrl = getApiBaseUrl();
        return {
            baseUrl: baseUrl,
            auth: {
                googleVerify: baseUrl + '/api/auth/google/verify',
                refresh: baseUrl + '/api/auth/refresh',
            },
            public: {
                proofs: baseUrl + '/api/public/proofs',
                aiModels: baseUrl + '/api/public/ai/models',
            },
            protected: {
                addToBlacklist: baseUrl + '/api/blacklist/add',
                checkBlacklist: baseUrl + '/api/blacklist/check',
            },
            analytics: {
                audioAccess: baseUrl + '/api/analytics/audio-access',
                autoplayBlock: baseUrl + '/api/analytics/autoplay-block',
                musicMute: baseUrl + '/api/analytics/music-mute',
                musicStay: baseUrl + '/api/analytics/music-stay',
                musicStats: baseUrl + '/api/analytics/music-stats',
            }
        };
    },
    get websocket() {
        return {
            url: getWebSocketUrl(),
        };
    },
};

export const SUPPORT_LINKS = {
    discord: 'https://discord.gg/rn9nVSuqXz',
    telegram: 'https://t.me/+h8bFGTaYa5wyMTc6',
    youtube: 'https://www.youtube.com/@aizer_play',
    email: 'mailto:stormhackinfo@gmail.com'
};

export const PAYMENT_MODAL_CONFIG = {
    supportMessageDelay: 30000 // 30 seconds in milliseconds
};

export default config;
